import { useState } from "react";
import { navLinks, contactInfo } from "@/pages/home/data";
import { useActiveSection, useScrolled } from "@/hooks/useScrollSpy";

const sectionIds = navLinks.map((l) => l.href.replace("#", ""));

export default function SiteNavbar() {
  const [open, setOpen] = useState(false);
  const scrolled = useScrolled(40);
  const active = useActiveSection(sectionIds);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled || open
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <nav
          aria-label="主导航"
          className="flex h-16 md:h-20 items-center justify-between gap-6"
        >
          <a
            href="#top"
            className="flex items-center gap-2.5 shrink-0 cursor-pointer"
            onClick={() => setOpen(false)}
          >
            <span
              className={`w-9 h-9 flex items-center justify-center rounded-md text-lg ${
                scrolled || open
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-50/15 text-background-50 ring-1 ring-background-50/40"
              }`}
            >
              <i className="ri-file-shield-2-line" aria-hidden="true"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span
                className={`font-heading text-base font-bold tracking-tight ${
                  scrolled || open ? "text-foreground-950" : "text-background-50"
                }`}
              >
                黑料投稿审核中心
              </span>
              <span
                className={`text-[11px] mt-0.5 tracking-wide ${
                  scrolled || open ? "text-foreground-500" : "text-background-200"
                }`}
              >
                流程透明 · 合规曝光
              </span>
            </span>
          </a>

          <ul className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => {
              const id = link.href.replace("#", "");
              const isActive = active === id;
              return (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className={`px-3 py-2 text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer ${
                      scrolled
                        ? isActive
                          ? "text-primary-600 bg-primary-50 font-medium"
                          : "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
                        : isActive
                          ? "text-background-50 bg-background-50/15 font-medium"
                          : "text-background-100 hover:text-background-50 hover:bg-background-50/10"
                    }`}
                  >
                    {link.label}
                  </a>
                </li>
              );
            })}
          </ul>

          <div className="hidden md:flex items-center gap-3 shrink-0">
            <a
              href={`mailto:${contactInfo.email}`}
              className={`text-sm whitespace-nowrap transition-colors ${
                scrolled
                  ? "text-foreground-600 hover:text-primary-600"
                  : "text-background-100 hover:text-background-50"
              }`}
            >
              {contactInfo.email}
            </a>
            <a
              href="#contact"
              className="px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
            >
              我要投稿
            </a>
          </div>

          <button
            type="button"
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-xl cursor-pointer transition-colors ${
              scrolled || open
                ? "text-foreground-900 hover:bg-background-100"
                : "text-background-50 hover:bg-background-50/10"
            }`}
          >
            <i className={open ? "ri-close-line" : "ri-menu-line"} aria-hidden="true"></i>
          </button>
        </nav>
      </div>

      {open && (
        <div className="lg:hidden border-t border-background-200 bg-background-50">
          <div className="px-4 py-4 flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="px-3 py-2.5 rounded-md text-sm text-foreground-800 hover:bg-background-100 hover:text-primary-600 transition-colors cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-2 px-3 py-2.5 rounded-md text-sm font-medium text-center bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
            >
              我要投稿
            </a>
            <a
              href={`mailto:${contactInfo.email}`}
              className="px-3 py-2.5 rounded-md text-sm text-center text-foreground-600 hover:bg-background-100 transition-colors cursor-pointer"
            >
              {contactInfo.email}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}